import ErrorIcon from '@mui/icons-material/Error';
import { Box, Typography } from '@mui/material';

type AccordionSummaryTitleProps = {
  title: string;
  count: number;
  isErrorIconShown?: boolean;
};

export const AccordionSummaryTitle = ({
  title = '',
  count = 0,
  isErrorIconShown = false,
}: AccordionSummaryTitleProps) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
    <Typography color="textPrimary">{`${title} (${count})`}</Typography>
    {isErrorIconShown ? <ErrorIcon color="error" fontSize="small" /> : null}
  </Box>
);
